module.exports = "<div class=\"fs-6 fc-5 fw-bold my-2 text-center\">\r\n    Test Genetico<br />Kit Salute VitæDNA\r\n</div>"